import React, { useState } from "react"
import Fade from "react-reveal/Fade"
import { useTranslation } from "react-i18next";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const QuestionAnswer = ({question, answer}) => {
	
	const [expanded, setExpanded] = useState(false);
	
	const toggleQuestion = () => {
		setExpanded(!expanded);
	};
	
	const {t} = useTranslation();
	return <>
		<div
			style={{
				borderBottom: '1px solid rgba(109, 124, 144, .12)'
			}}
			className="xxs:p-2 sm:p-0 pb-10"
		>
			<h4 className="font-bold text-black text-xl rounded-xl p-5 xxs:text-lg sm:text-xl cursor-pointer flex justify-between" onClick={toggleQuestion}>
				{t(question)}
				<div id={`toggle-icon ${expanded ? 'expanded' : ''}`}>
					{!expanded ? <ArrowDropDownIcon/> : <ArrowDropUpIcon/>}
				</div>
				
			</h4>
			{<div className={`answer-container ${expanded ? 'expanded' : ''} max-h-200 sm:max-h-400 xxs:max-h-400`}>
				<p style={{color: '#6D7C90'}} className={`p-5 pt-0 text-lg rounded-xl text-justify duration-10 ease-out`}>
					{t(answer)}
				</p>
			</div>}
		</div>
	</>
}

QuestionAnswer.defaultProps = {
	question: 'Hello world',
	answer: 'Say sth'
}

export default QuestionAnswer
